import PropTypes from 'prop-types';

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Tab = ({ tabArray, handleTabChange, tabValue }) => {
  return(
    <Box 
      sx={{ 
        mt: 1,
        width: '100%', 
        display: 'flex',
        textAlign: 'center',
        cursor: 'pointer',
      }}
    >
      { 
        tabArray.map((tabName, index) => (
          <Box 
            sx={{
              border: '1px solid grey',
              width: '50%',
              padding: 1,
              background: (tabValue == tabName) ? '#1976d2' : null,
            }} 
            key={index}
            onClick={handleTabChange}
          >
            <Typography 
              color={(tabValue == tabName) ? '#fff' : 'black'}
            >
              {tabName}
            </Typography>
          </Box>
        ))
      }
    </Box>
  );
};

Tab.propTypes = {
  tabArray: PropTypes.array.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  tabValue: PropTypes.string.isRequired,
};

export default Tab;